<template>
  <div class="grid scroll-div">
    <div class="grid-title bg-primary">
      <h4 class="text-bold text-white">Next To Order</h4>
    </div>
    <div class="grid-body p-0">
      <div class="col-md-6 p-14 text-left">
        <div class="row">
          <div class="col-md-2">
            <p-radio
              class="p-default"
              value="available"
              name="fabricFilter"
              @change="applyFabricFilter()"
              v-model="fabricFilter"
              color="success"
            >
              Available
            </p-radio>
          </div>
          <div class="col-md-2">
            <p-radio
              class="p-default"
              value="keep"
              name="fabricFilter"
              @change="applyFabricFilter()"
              v-model="fabricFilter"
              color="success"
            >
              Future=Keep
            </p-radio>
          </div>
          <div class="col-md-2">
            <p-radio
              class="p-default"
              value="all"
              name="fabricFilter"
              @change="applyFabricFilter()"
              v-model="fabricFilter"
              color="success"
            >
              All
            </p-radio>
          </div>
        </div>
      </div>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th class="pointer" @click="sort('id')">
              ID
              <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
            <th class="pointer" @click="sort('name')">
              Name
              <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
            <th class="text-center pointer" @click="sort('available_stock')">
              Free Stock
              <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
            <th @click="sort('oos_date_int')">
              Sold Out
              <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
            <th class="text-center pointer" @click="sort('reserved_stock')">
              Next Order
              <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
            <th class="text-center pointer" @click="sort('reserved_stock')">
              ETA Next Order
              <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
            <th @click="sort('oos_date_int')">
              Sold Out 2
              <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
            <th class="text-center pointer" @click="sort('reserved_stock')">
              Next Order 2
              <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
            <th class="text-center pointer" @click="sort('reserved_stock')">
              ETA Next Order 2
              <i class="fa fa-sort" aria-hidden="true"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(fabric, index) in fabrics" :key="index">
            <td>
              <router-link :to="'/fabric/update/' + fabric.id">{{
                $Fabric.getCode(fabric.id)
              }}</router-link>
            </td>
            <td>
              <router-link :to="'/fabric/update/' + fabric.id"
                >{{ fabric.name }}
              </router-link>
            </td>
            <td class="text-right">{{ ezy.comma(fabric.in_stock) }}</td>
            <td class="text-right text-capitalize">
              {{ fabric.out_of_stock_date }}
            </td>
            <td class="text-right text-capitalize">
              {{ fabric.next_order_date }}
            </td>
            <td class="text-right text-capitalize">
              {{ fabric.next_order_eta }}
            </td>
            <td class="text-right text-capitalize">
              {{ fabric.out_of_stock_date2 }}
            </td>
            <td class="text-right text-capitalize">
              {{ fabric.next_order_date2 }}
            </td>
            <td class="text-right text-capitalize">
              {{ fabric.upcoming_eta }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["pageData"],
  data() {
    return {
      fabricFilter: "keep",
      fabrics: [],
      notFilteredFabrics: [],
    };
  },
  methods: {
    sort(column, sortType) {
      if (sortType) {
        // manual sorting
        this.sortType = sortType;
      } else {
        // table header sorting
        this.sortType = this.sortType === "asc" ? "desc" : "asc";
      }

      this.fabrics = _.orderBy(this.fabrics, [column], [this.sortType]);
    },
    applyFabricFilter() {
      if (this.fabricFilter === "all") {
        this.fabrics = this.notFilteredFabrics;
      }
      if (this.fabricFilter === "available") {
        this.fabrics = this.notFilteredFabrics.filter((fabric) => {
          return (
            fabric.status === "available" ||
            fabric.status === "soon_sold_out_coming_back" ||
            fabric.status === "soon_sold_out_not_coming_back"
          );
        });
      }
      if (this.fabricFilter === "keep") {
        this.fabrics = this.notFilteredFabrics.filter((fabric) => {
          return fabric.future === "keep";
        });
      }
    },
  },
  watch: {
    "pageData.fabricOrderingTable": function () {
      let fabricOrderingTable = this.pageData.fabricOrderingTable;

      const nextOrderMarginDays = 120;

      if (fabricOrderingTable) {
        this.notFilteredFabrics = fabricOrderingTable.map((f) => {
          let outOfStockDate =
            f["out_of_stock_date"] > 0
              ? moment.unix(f["out_of_stock_date"]).format("DD MMM, YYYY")
              : "";
          let nextOrderDate =
            f["out_of_stock_date"] > 0
              ? moment
                  .unix(f["out_of_stock_date"])
                  .subtract(nextOrderMarginDays, "days")
                  .format("DD MMM, YYYY")
              : "";

          if (f["out_of_stock_date"] < 0) {
            outOfStockDate = "No data";
            nextOrderDate = "No data";
          }

          f["oos_date_int"] = parseInt(f["out_of_stock_date"]);
          f["out_of_stock_date"] = outOfStockDate;
          f["next_order_date"] = nextOrderDate;
          f["delivery_date"] = ezy.date(f["delivery_date"]);
          f["in_stock"] = f.in_stock * 1;
          f["code"] = $Fabric.getCode(f.id);
          f["delivered_amount"] =
            f.delivered_amount <= 0 ? "" : ezy.comma(f.delivered_amount);
          f["ordered_amount"] =
            f.ordered_amount <= 0 ? "" : ezy.comma(f.ordered_amount);
          f["rolls"] = [];
          f["rolls_loaded"] = false;
          f["show_rolls"] = false;

          if (f["used_calculation_value"] && f["oos_date_int"] > 0) {
            f["out_of_stock_date"] =
              f["out_of_stock_date"] + " (" + f["used_calculation_value"] + ")";
          }

          if (f["next_order_eta"] !== null) {
            f["next_order_eta"] = moment(
              f["next_order_eta"],
              "YYYY-MM-DD"
            ).format("DD MMM, YYYY");
          } else {
            f["next_order_eta"] = "";
          }

          if (f["upcoming_eta"] !== null) {
            f["upcoming_eta"] = moment(f["upcoming_eta"], "YYYY-MM-DD").format(
              "DD MMM, YYYY"
            );
          } else {
            f["upcoming_eta"] = "";
          }

          /**
           * Compute fabric average usage
           */

          let averageUsagePerDay = 0;
          if (f.used_calculation_value === "U/60") {
            averageUsagePerDay =
              parseFloat(f.total_usage_60d) / parseFloat(f.active_days_60d);
          }
          if (f.used_calculation_value === "U/30") {
            averageUsagePerDay =
              parseFloat(f.total_usage_30d) / parseFloat(f.active_days_30d);
          }
          if (f.used_calculation_value === "S/30") {
            averageUsagePerDay =
              parseFloat(f.total_sales_30d) / parseFloat(f.active_days_30d);
          }
          if (f.used_calculation_value === "S/60") {
            averageUsagePerDay =
              parseFloat(f.total_sales_60d) / parseFloat(f.active_days_60d);
          }

          const openStock =
            parseFloat(f.in_stock) + parseFloat(f.left_amount) - 30;
          if (averageUsagePerDay > 0 && parseFloat(f.left_amount) > 0) {
            const remainingDaysForOpenStock =
              openStock / (averageUsagePerDay * 1.2); // add 20% margin on average usage
            f["out_of_stock_date2"] = moment()
              .add(remainingDaysForOpenStock, "days")
              .format("DD MMM, YYYY");
            f["next_order_date2"] = moment()
              .add(remainingDaysForOpenStock, "days")
              .subtract(nextOrderMarginDays, "days")
              .format("DD MMM, YYYY");
          } else {
            f["out_of_stock_date2"] = "";
            f["next_order_date2"] = "";
          }

          return f;
        });
        this.applyFabricFilter();
        this.sort("id", "asc");
      }
    },
  },
};
</script>

<style scoped>
</style>
